// Admin-only staff provisioning client. Hits /api/admin/* which (server-side) creates the
// real Cognito login AND the DB row in one flow, and disables/deactivates on removal.
// Auth-header pattern mirrors OpsDrivers / agentApi (prefer a fresh Cognito session token).
import { getCurrentSession } from './authService';

const API_BASE = process.env.REACT_APP_MOVORRA_API_URL || 'http://localhost:8081';

async function authHeaders(authSession) {
  let token = authSession?.idToken;
  try { const s = await getCurrentSession(); token = s.idToken; } catch (e) {}
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

async function request(path, opts, authSession) {
  const headers = await authHeaders(authSession);
  const res = await fetch(`${API_BASE}${path}`, { headers, ...opts });
  if (!res.ok && res.status !== 204) {
    let detail = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      detail = body.error || detail;
    } catch (e) { /* non-JSON body */ }
    throw new Error(detail);
  }
  if (res.status === 204) return null;
  return res.json().catch(() => null);
}

export const createDispatcher = (payload, authSession) =>
  request('/api/admin/dispatchers', { method: 'POST', body: JSON.stringify(payload) }, authSession);

// hard=true → permanently delete the login + DB row (not just deactivate).
export const removeDispatcher = (userId, authSession) =>
  request(`/api/admin/dispatchers/${encodeURIComponent(userId)}?hard=true`, { method: 'DELETE' }, authSession);

export const createDriver = (payload, authSession) =>
  request('/api/admin/drivers', { method: 'POST', body: JSON.stringify(payload) }, authSession);

export const removeDriver = (userId, authSession) =>
  request(`/api/admin/drivers/${encodeURIComponent(userId)}?hard=true`, { method: 'DELETE' }, authSession);
